<template>
  <el-popover
    ref="IConfirmPopover"
    :placement="placement"
    :width="width"
    :trigger="trigger"
    class="IConfirmPopover"
  >
    <template #reference>
      <slot name="reference" />
    </template>

    <div class="IConfirmPopoverContent">
      <template v-if="$slots.content">
        <slot name="content" />
      </template>
      <template v-else>
        {{ content }}
      </template>

      <div class="tw-grid tw-grid-cols-2 tw-justify-between tw-mt-4 tw-gap-2">
        <i-button
          class="tw-w-full"
          @click="handleCancel"
        >
          {{ cancelText || $t('common.actions.cancel') }}
        </i-button>
        <i-button
          type="primary"
          class="tw-w-full"
          @click="handleSubmit"
        >
          {{ submitText || $t('common.actions.save') }}
        </i-button>
      </div>
    </div>
  </el-popover>
</template>

<script>
export default {
  props: {
    placement: {
      type: String,
      default: 'bottom',
    },
    trigger: {
      type: String,
      default: 'click',
    },
    width: {
      type: Number,
      default: 357,
    },
    content: {
      type: String,
      default: null,
    },
    cancelText: {
      type: String,
      default: null,
    },
    submitText: {
      type: String,
      default: null,
    },
  },

  methods: {
    close() {
      this.$refs.IConfirmPopover.hide();
    },
    handleCancel() {
      this.$emit('cancel');
      this.close();
    },
    handleSubmit() {
      this.$emit('submit');
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
.IConfirmPopover {
  &Content {
    @apply tw-font-medium;
  }
}
</style>
